{
  gsap.registerPlugin(ScrollTrigger);
  
  class animatedElement extends HTMLElement {
    constructor(){
      super();
      this._fixWpAdminClassName()
      if(!window.coolHelperFunctions.prefersReducedMotion()) {
        this._startAnimationListener()
      }
    }

    _fixWpAdminClassName(){
      if (this.hasAttribute('className')) {
        this.classList = this.getAttribute('className');
        this.removeAttribute('className');
      }
    }

    _startAnimationListener(){
      const elementTriggerStart = this.getAttribute('element-trigger-start') || 'top';
      const screenTriggerStart = this.getAttribute('screen-trigger-start') || 'bottom';
      const elementTriggerEnd = this.getAttribute('element-trigger-end') || 'bottom';
      const scrubSpeed = parseFloat(this.getAttribute('speed')) || 1;
      const screenTriggerEnd = this.getAttribute('screen-trigger-end') || 'top';
      const from = JSON.parse(this.getAttribute('from') || '{}');
      const to = JSON.parse(this.getAttribute('to') || '{}');
      const exit = this.hasAttribute('exit') ? JSON.parse(this.getAttribute('exit')) : null
      const easing = this.getAttribute('easing') || 'linear';
      const animations = JSON.parse(this.getAttribute('animations') || '[]');

      const scrollConfig = {
        trigger: this,
        start: `${elementTriggerStart} ${screenTriggerStart}`,
        end: `${elementTriggerEnd} ${screenTriggerEnd}`,
        scrub: scrubSpeed,
        ease: easing,
      }

      this.removeAttribute('element-trigger-start')
      this.removeAttribute('screen-trigger-start')
      this.removeAttribute('element-trigger-end')
      this.removeAttribute('screen-trigger-end')
      this.removeAttribute('from')
      this.removeAttribute('to')
      this.removeAttribute('speed')
      this.removeAttribute('exit')
      this.removeAttribute('easing')
      this.removeAttribute('animations')

      if(animations.length){
        animations.forEach((step, index) => {
          const {
            'el-trigger-start': elementTriggerStart,
            'screen-trigger-start': screenTriggerStart,
            'el-trigger-end': elementTriggerEnd,
            'screen-trigger-end': screenTriggerEnd,
            from,
            to
          } = step;

          // Use GSAP to create timeline animations based on parsed values
          gsap.fromTo(this, from, {
            ...to,
            scrollTrigger: {
              trigger: this,
              start: `${elementTriggerStart} ${screenTriggerStart}`,
              end: `${elementTriggerEnd} ${screenTriggerEnd}`,
              scrub: scrubSpeed,
              ease: easing,
            }
          });
        });
      } else if(exit){
        const tl = gsap.timeline({ scrollTrigger: scrollConfig })
        tl.fromTo(this, from, { ...to, ease: easing })
          .to(this, { ...exit, ease: easing })
      } else {
        gsap.fromTo(this, from, { ...to, scrollTrigger: scrollConfig });
      }
    }
  }
  customElements.define('animated-element', animatedElement)
}